//WMCE-455: Reduced muster initialization --
//Introduced Authenticated wrapper in Provider 2 to recieve values of the LoginCredentials in authenticationJson and disable Provider1
import React, { PureComponent } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';

class AuthenticatedWrapper extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      stateProviderReady : false
    };
  }

  render() {
    if(this.props.auth.portfolioLoaded && this.props.portfolio.busymode){
      this.props.userGotPortfolio();
    }
    return (null);
  }

  componentDidMount(){
    this.props.getConfig();
    this.props.setAuthenticationJson(this.props.authenticationJson);
    this.props.authenticatedwrapper();
  }
}


export default createContainer({
  $queries: {
    getConfig: { $call:'app.getConfig' },
    portfolio: { busymode : true },
    app:{
      user:{
        pfReady: true
      }
    },
    auth:{
      stateProviderReady: true,
      portfolioLoaded: true
    },
    setAuthenticationJson: { $set: 'auth.authenticationJson' },
    authenticatedwrapper: { $call: 'auth.authenticatedwrapper' }
  },
})(AuthenticatedWrapper);
